// extracted by mini-css-extract-plugin
export default {"globe":"KardeshevCounter_globe__V-9AW","number":"KardeshevCounter_number__jhwKo"};